import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, CircularProgress, Typography, IconButton, Tooltip } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import {
  HeaderLeftContent,
  HeaderRightContent,
  StyledHeader,
} from "../../Common/styles/header";
import {
  StyledTabs,
  StyledTab,
  a11yProps,
  // MainTabPanel,
  CustomTabPanel,
} from "../../Common/UI/TabPanel";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { openHelp } from "../../../Redux/reducers/helpSlice";
// import OverviewTab from "./Tabs/OverviewTab";
import LogoutContainer from "../../Layout/LogoutContainer";
// import Features from "./Tabs/Features";
// import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { HelpOutline } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import Features from "./Tabs/Features";
import UserTheme from "./Tabs/UserTheme";
import { permissions, platformAdminPermissions } from "../../../utils/roles";

const OrganisationSettings = () => {
  const { t } = useTranslation("sidebar");
  const dispatch = useAppDispatch();
  const [submitLoader, setSubmitLoader] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [type, setType] = useState(searchParams.get("type") ?? "features");
  const [toggleLoader, setToggleLoader] = useState(false);
  const [editFeatures, setEditFeatures] = useState(false);
  const { studyPermissions } = useAppSelector((state) => state.study);
  const [canEditSettings] = useState(
    studyPermissions.includes(permissions.studySettings)
  );
  const { platformPermissions } = useAppSelector((state) => state.user);
  const canViewPlatform = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.viewPlatform),
    [platformPermissions],
  );

  useEffect(() => {
    const params = new URLSearchParams();
    if (type) {
      params.set("type", type);
    }
    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, type]);

  const handleChange = (_1: any, val: string) => {
    setType(val);
  };

  // const handleBack = () => {
  //   navigate(-1);
  // };
  const refreshPage = () => {
    setToggleLoader((prev) => !prev);
  };
  const handleEditFeatures = () => {
    refreshPage();
    setEditFeatures(true);
  };
  const handleCloseEditFeatures = () => {
    setEditFeatures(false);
    refreshPage();
  };

  const submitHandler = () => {
    setSubmitLoader(true);
    setSubmitLoader(false);
  };

  return (
    <>
      <Box
        sx={{
          height: "64px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <Box sx={{ ml: "auto" }}>
          <LogoutContainer />
        </Box>
      </Box>
      {/* <Box sx={HeaderStyle}>
        <IconButton onClick={handleBack}>
          <ChevronLeft sx={{ cursor: "pointer" }} fontSize="large" />
        </IconButton>
        <Typography fontSize={20} fontWeight="medium" color="text.primary">
          Organisation
        </Typography>
      </Box> */}
      <StyledHeader margin={0}>
        <Box sx={{ ...HeaderLeftContent, gap: 1 }}>
          <Typography fontSize={20} fontWeight={600} color="text.primary">
            {editFeatures
              ? "Edit Features"
              : type === "overview"
              ? "Settings"
              : "Settings"}
          </Typography>
        </Box>

        <Box sx={HeaderRightContent}>
          {type === "features" && editFeatures ? (
            !submitLoader ? (
              <>
                <Button variant="outlined" onClick={handleCloseEditFeatures}>
                  Cancel
                </Button>
                <Button variant="contained" onClick={submitHandler}>
                  Save
                </Button>
              </>
            ) : (
              <CircularProgress size={25} />
            )
          ) : (
            type === "features" && (
              <Button
                variant="outlined"
                onClick={handleEditFeatures}
                startIcon={<EditIcon />}
              >
                Edit
              </Button>
            )
          )}
          {canViewPlatform && (
            <Tooltip title={t("HELP_TOOLTIP")}>
              <IconButton
                onClick={() => dispatch(openHelp("org-settings-users"))}
                size="small"
              >
                <HelpOutline />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </StyledHeader>
      <Box sx={{ borderTop: 1, borderColor: "#E5E7EB" }}>
        <StyledTabs value={type} onChange={handleChange}>
          <StyledTab label="Features" value="features" {...a11yProps(0)} />
          <StyledTab label="User Theme" value="user_theme" {...a11yProps(1)} />
        </StyledTabs>
      </Box>
      <Box sx={{ p: 3, overflow: "auto", height: "calc(100vh - 201px)" }}>
        <CustomTabPanel value={type} index={"features"}>
          <Features
            handleCloseEditFeatures={handleCloseEditFeatures}
            toggleLoader={toggleLoader}
            editFeatures={editFeatures}
          />
        </CustomTabPanel>
        <CustomTabPanel value={type} index={"user_theme"}>
          <UserTheme canEdit={canEditSettings} />
        </CustomTabPanel>
      </Box>
    </>
  );
};

export default OrganisationSettings;
